import { render, staticRenderFns } from "./collapsible-block.vue?vue&type=template&id=7186ded8"
import script from "./collapsible-block.vue?vue&type=script&lang=js"
export * from "./collapsible-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports